import type { HistogramSeries } from '../types/histogram.js';

/**
 * Return max series value
 * @param histogramSeries - given histogramSeries
 * @internal
 */

export const getMaxSeriesValue = (histogramSeries: HistogramSeries) =>
  Math.max(...histogramSeries.bins.map((bin) => Math.abs(bin.value)));
